@import '../../style/globals.scss';

.Icon {
    path {
        fill: var(--token-LEGACY-accent-theme-1-interface-interface-white);
    }
}
